import { useState } from 'react';

interface Props {
  onSearch: (query: string) => void;
  busy: boolean;
}

const EXAMPLE_QUERIES = [
  'where has anyone changed their mind about scaling laws?',
  'karpathy on whether RL is needed for reasoning',
  'hassabis vs amodei on AGI safety',
  'best episodes on mechanistic interpretability',
];

export function SearchBar({ onSearch, busy }: Props) {
  const [query, setQuery] = useState('');

  function submit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = query.trim();
    if (!trimmed || busy) return;
    onSearch(trimmed);
  }

  return (
    <form className="search-bar" onSubmit={submit}>
      <div className="search-row">
        <span className="search-prompt">&gt;</span>
        <input
          className="search-input"
          type="text"
          placeholder="ask about a claim, a person, a mind-change…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoFocus
          maxLength={500}
          disabled={busy}
        />
        <button className="search-button" type="submit" disabled={busy || !query.trim()}>
          {busy ? 'searching' : 'search'}
        </button>
      </div>
      {!busy && query.length === 0 && (
        <ul className="example-queries">
          <li className="example-queries-label">try:</li>
          {EXAMPLE_QUERIES.map((q) => (
            <li key={q}>
              <button type="button" className="example" onClick={() => { setQuery(q); onSearch(q); }}>
                {q}
              </button>
            </li>
          ))}
        </ul>
      )}
    </form>
  );
}
